import { specialDayDateLabel, specialDayHoursLabel } from "../../../../utils/SpecialDayUtils";
import "./SpecialDay.css";

// Quantos agendamentos afetados aparecem por nome antes do "e mais".
const AFFECTED_PREVIEW = 2;

// "Segunda-feira, 02/11/2026": o dia da semana ajuda a recepção a reconhecer o feriado.
const dateRenderer = (params) => (params.data?.specialDate ? specialDayDateLabel(params.data.specialDate) : '-');

// Selo "Fechada" ou "09:00 às 14:00".
const hoursRenderer = (params) => (params.data
    ? <span className={`special-day-hours ${params.data.isOpen ? 'is-open' : 'is-closed'}`}>{specialDayHoursLabel(params.data)}</span>
    : null);

const branchesRenderer = (params) => (params.data?.branchNames || []).join(', ') || '-';

// Quantos agendamentos já marcados ficaram fora do que as filiais vão atender, com os primeiros.
const affectedRenderer = (params) => {
    const affected = params.data?.affectedAppointments || [];
    if (affected.length === 0) {
        return 'Nenhum';
    }

    const preview = affected.slice(0, AFFECTED_PREVIEW)
        .map((appointment) => `${String(appointment.scheduledDate || '').slice(11, 16)} ${appointment.customerName || 'Cliente'}`)
        .join(', ');
    return `${affected.length}: ${preview}${affected.length > AFFECTED_PREVIEW ? ` e mais ${affected.length - AFFECTED_PREVIEW}` : ''}`;
};

// Colunas da grade de feriados e horários especiais. A ordem vem do servidor (pela data), então
// nenhuma coluna ordena.
export const Columns = [
    {
        headerName: 'date',
        field: 'specialDate',
        cellRenderer: dateRenderer,
        sortable: false,
        width: 220
    },
    {
        headerName: 'special_day_operation',
        field: 'isOpen',
        cellRenderer: hoursRenderer,
        sortable: false,
        width: 160
    },
    {
        headerName: 'reason',
        field: 'reason',
        sortable: false,
        width: 180
    },
    {
        headerName: 'branches',
        field: 'branchNames',
        cellRenderer: branchesRenderer,
        sortable: false,
        width: 220
    },
    {
        headerName: 'appointments_to_reschedule',
        field: 'affectedAppointments',
        cellRenderer: affectedRenderer,
        sortable: false,
        width: 320
    }
];
